import React, { useContext, useState, useEffect } from 'react'
import { Row, Col, Form, Button } from 'react-bootstrap'
import { LanguageContext } from '../Language/LanguageContext'
import SunEditor from 'suneditor-react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
    faGlobeAsia, 
    faBuilding, 
    faUsers,
    faNewspaper,
    faCheckCircle,
    faCheck,
    faTimes,
    faFile,
    faPen,
    faQuestionCircle,
    faPlus,
    faTrash,
    faWalking,
    faWindowMaximize
} 
    from '@fortawesome/free-solid-svg-icons'
import { listCompany } from '../Network/Company'
import { listDepartment } from '../Network/Department'
import { 
    addNewsImages, 
    removeNewsImages,
    addNewsDepartment, 
    removeNewsDepartment,
    addMultipleChoice,
    removeMultipleChoice,
    markAnswerChoice,
    viewNews,
    updateNews
} from '../Network/News'
import DatePicker from "react-datepicker";
import { useHistory, useParams } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import 'suneditor/dist/css/suneditor.min.css'
import "./CreateNews.css"
import { NotifyContext } from '../Library/Notify'
import { HeaderTitle, Checkbox, Loading } from '../Library'
import { baseURL } from '../Network/Config'
import ImageModal from './ImageModal'
import dayjs from 'dayjs'
import MultiSelect from "react-multi-select-component";
import { setDocumentTitle } from '../AppTitle'
import { RoleContext } from '../Role/RoleContext'

function UpdateNews() {
    const { news_id } = useParams()
    const history = useHistory()
    const prefixAuthority = "NEWS_"
    const globalAuthority = "SET_GLOBAL"
    const companyAuthority = "SET_COMPANY"
    const role = useContext(RoleContext)
    const notify = useContext(NotifyContext)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.news
    
    const newsType = [
        {value: "NORMAL", label: lang.general, icon: faNewspaper},
        {value: "VOTE", label: lang.vote, icon: faCheckCircle},
        {value: "REGISTER", label: lang.register, icon: faPen},
        {value: "INFORM", label: lang.inform, icon: faFile},
        {value: "QUIZ", label: lang.quiz, icon: faQuestionCircle}
    ]

    const myDate = new Date()
    const myDateAhead = new Date().setMonth(new Date().getMonth() + 3)
    
    const [isLoading, setIsLoading] = useState(false)

    const [company, setCompany] = useState([])
    const [selectedCompany, setSelectedCompany] = useState("");
    const [isGlobal, setGlobal] = useState(false)
    const [department, setDepartment] = useState([])
    const [prevSelectedDepartment, setPrevSelectedDepartment] = useState([])
    const [selectedDepartment, setSelectedDepartment] = useState([])
    const [isShowImageModal, setShowImageModal] = useState(false)
    const [isShowMultipleImageModal, setShowMultipleImageModal] = useState(false)
    const [selectedThumbnail, setSelectedThumbnail] = useState({imageId: null, path: null})
    const [prevImages, setPrevImages] = useState([])
    const [headerImages, setHeaderImages] = useState([])

    const [title, setTitle] = useState("")
    const [subTitle, setSubTitle] = useState("")
    const [publisher, setPublisher] = useState("")
    const [content, setContent] = useState("")
    const [publication, setPublication] = useState(0);
    const [publicationDate, setPublicationDate] = useState(myDate)
    const [expireDate, setExpireDate] = useState(myDateAhead)
    const [selectedTypeNews, setTypeNews] = useState(newsType[0].value)
    const [maximumRegister, setMaximumRegister] = useState(0)
    const [isShowVisitor, setIsShowVisitor] = useState(false)
    const [isShowInformationScreen, setIsShowInformationScreen] = useState(false)
    const [voteOption, setVoteOption] = useState("")
    const [voteChoices, setVoteChoices] = useState([])
    const [quizOption, setQuizOption] = useState("")
    const [quizChoices, setQuizChoices] = useState([])
    const [answerChoice, setAnswerChoice] = useState([])
    const [isError, setError] = useState(false)

    const [toAddImage, setToAddImage] = useState([])
    const [toRemoveImage, setToRemoveImage] = useState([])

    useEffect(()=>{
        setDocumentTitle("Edit news")
        companyList()
        fetchData()
        
    }, [])

    const fetchData = () =>{
        setIsLoading(true)
        viewNews(news_id,
            (data)=>{
                console.log(data)
                let news = data.news
                setTitle(news.title)
                setSubTitle(news.subtitle)
                setContent(news.content)
                setPublisher(news.publisher)
                setIsShowVisitor(news.isShowVisitor)
                setIsShowInformationScreen(news.isShowInformationScreen)
                if(news.thumbnail !== null){
                    setSelectedThumbnail({imageId: news.thumbnail.imageId, path: news.thumbnail.imagePath})
                }
                setHeaderImages([])
                news.images.forEach((item)=>{
                    setPrevImages(oldArr => [...oldArr, {imageId: item.imageId, path: item.imagePath}])
                    setHeaderImages(oldArr => [...oldArr, {imageId: item.imageId, path: item.imagePath}])
                })
                setPublicationDate(news.publishDate)
                setExpireDate(news.newsExpiredDate)

                if(!news.global){
                    if(news.departments !== null){
                        let companyId = news.departments[0].companyId
                        var departmentsList = []
                        news.departments.forEach((item)=>{
                            departmentsList.push({ label: item.name, value: item.id })
                        })
                        setSelectedCompany(companyId)
                        setSelectedDepartment(departmentsList)
                        setPrevSelectedDepartment(departmentsList)
                        departmentList(companyId)
                    }
                    setPublication(2)
                    setGlobal(false)
                
                }else{
                    setGlobal(true)
                }

                setTypeNews(news.type)
                if(news.type === newsType[1].value){
                    setVoteChoices([])
                    news.choices.forEach((item)=>{
                        setVoteChoices(oldArr => [...oldArr, item.choiceValue])
                    })

                }else if(news.type === newsType[2].value){
                    setMaximumRegister(news.maximumRegister)
                }
                
                else if(news.type === newsType[4].value){
                    setQuizChoices([])
                    news.choices.forEach((item)=>{
                        setQuizChoices(oldArr => [...oldArr, item.choiceValue])
                        if(item.answer === true){
                            setAnswerChoice(oldArr => [...oldArr, item.choiceValue])
                        }
                    })
                }

                setIsLoading(false)
            },
            (error)=>{
                setIsLoading(false)
                notify.showNotify("Something wrong loading information", error.message, 2)
            })
    }

    const companyList = () =>{
        listCompany(
            (data)=>{
                setCompany(data)
            },
            (error)=>{
                notify.showNotify("Something wrong Company", error.message, 2)
            }
        )
    }

    const departmentList = (companyId) =>{
        listDepartment(companyId,
            (data)=>{
                var list = []
                data.forEach((item)=>{
                    list.push({ label: item.name, value: item.id })
                })
                setDepartment(list)
            },
            (error)=>{
                notify.showNotify("Something wrong Department", error.message, 2)
            }
        )
    }

    const switchPublication = (pub) =>{
        setPublication(pub)
        if(pub === 1 || pub === 2 ){
            companyList()
        }else{
        }
    }

    const addChoice = () =>{
        if(selectedTypeNews === newsType[1].value){
            if(!voteOption){ return; }
            setVoteChoices(oldArr => [...oldArr, voteOption])
            setVoteOption("")
        }
        else if(selectedTypeNews === newsType[4].value){
            if(!quizOption){ return; }
            setQuizChoices(oldArr => [...oldArr, quizOption])
            setQuizOption("")
        }
    }

    const deleteChoice = (toDelete) =>{
        if(selectedTypeNews === newsType[1].value){
            setVoteChoices(voteChoices.filter(item=> item !== toDelete))
        }
        else if(selectedTypeNews === newsType[4].value){
            setQuizChoices(quizChoices.filter(item=> item !== toDelete))
            if(answerChoice.some(el => el === toDelete)){
                setAnswerChoice(answerChoice.filter(item=>item !== toDelete))
            }
        }
    }

    // Submit to API
    const submit = () =>{
        if(!title || !content){ 
            setError(true)
            notify.showNotify(lang.not_complete, lang.not_complete_desc, 1)
            return; 
        }

        let isGlobal = publication === 0 ? true:false
        let publishDate = dayjs(publicationDate).valueOf()
        let expiredDate = dayjs(expireDate).valueOf()

        setIsLoading(true)
        updateNews(
            news_id,
            title,
            subTitle,
            publisher,
            content,
            selectedTypeNews,
            selectedThumbnail.imageId,
            isGlobal,
            publishDate,
            expiredDate,
            maximumRegister,
            isShowVisitor,
            isShowInformationScreen,
            (data)=>{
                notify.showNotify(lang.update_success, lang.update_success_desc, 0)
                addImages(news_id)
                if(selectedTypeNews === "VOTE"){
                    addVoteChoice(news_id)
                }else if(selectedTypeNews === "QUIZ"){
                    addQuizChoice(news_id)
                }

                if(!isGlobal){
                    addByDepartment(news_id)
                }

                history.push("/news")
            },
            (error)=>{
                setIsLoading(false)
                notify.showNotify("Something wrong update", error.message, 2)
            }
        )
    }

    const addImages = (newsId) =>{
        toRemoveImage.forEach((item)=>{
            removeNewsImages(newsId, item.imageId,
                ()=>{
                    setToRemoveImage([])
                },
                (error)=>{
                    notify.showNotify("Something wrong header image", error.message, 2)
                })
        })

        toAddImage.map((item)=>{
            addNewsImages(newsId, item.imageId,
                ()=>{
                    setToAddImage([])
                },
                (error)=>{
                    notify.showNotify("Something wrong header image", error.message, 2)
                })
        })
        
    }

    const addByDepartment = (newsId) =>{
        selectedDepartment.forEach((item)=>{
            var newItem = false
            if(!prevSelectedDepartment.find(el=>el.value === item.value)){
                newItem = true
            }else{
                newItem = false
            }
            
            if(newItem){
                addNewsDepartment(newsId, item.value,
                    ()=>{ },
                    (error)=>{
                        notify.showNotify("Something wrong adding department", error.message, 2)
                    })
            }
            
        })

        prevSelectedDepartment.forEach((item)=>{
            if(!selectedDepartment.find(el=>el.value === item.value)){
                removeNewsDepartment(newsId, item.value,
                    ()=>{},
                    (error)=>{
                        notify.showNotify("Something wrong removing department", error.message, 2)
                    }
                )
            }
        })
    }

    const addVoteChoice = (newsId) =>{
        removeMultipleChoice(newsId,
            ()=>{
                if(voteChoices.length > 0){
                    addMultipleChoice(voteChoices, newsId,
                        ()=>{ },
                        (error)=>{
                            notify.showNotify("Something wrong vote choice", error.message, 2)
                        })
                }
            },
            (error)=>{
                notify.showNotify("Something wrong remove vote choice", error.message, 2)
            })
        
    }

    const selectAnswerChoice = (choice) =>{
        if(!answerChoice.some(el => el === choice)){
            setAnswerChoice(oldArr=>[...oldArr, choice])
        }else{
            setAnswerChoice(answerChoice.filter(item=>item !== choice))
        }
    }

    const addQuizChoice = (newsId) =>{
        removeMultipleChoice(newsId, 
            ()=>{
                addMultipleChoice(quizChoices, newsId,
                    (data)=>{
                        if(answerChoice.length > 0){
                            var rightChoice = null
                            data.forEach((item)=>{
                                if(answerChoice.some(el => el === item.choiceValue)){
                                    rightChoice = item
                                }
                            })
                            markAnswerChoice(rightChoice.id,
                                ()=>{},
                                (error)=>{
                                    notify.showNotify("Something wrong mark answer choice", error.message, 2)
                                })
                        }
                    },
                    (error)=>{
                        notify.showNotify("Something wrong adding quiz choice", error.message, 2)
                    })
            },
            (error)=>{
                notify.showNotify("Something wrong remove quiz choice", error.message, 2)
            })
        
    }

    return (
        <div id="create-news">
            { isLoading ? <Loading/>: null }
            <HeaderTitle title={lang.edit_news} isShowBack backTo="/news"/>
            <Row>
                <Col md={10} lg={8} xl={6}>
                    <Form
                    onSubmit={(e)=>{
                        e.preventDefault()
                        submit()
                    }}
                    >
                        <Form.Group>
                            <Form.Label>{lang.news_title}</Form.Label>
                            <Form.Control
                            value={title}
                            onChange={(e)=>{
                                setTitle(e.target.value)
                            }}
                            isInvalid={isError && !title}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.news_subtitle}</Form.Label>
                            <Form.Control
                            value={subTitle}
                            onChange={(e)=>{
                                setSubTitle(e.target.value)
                            }}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.publisher}</Form.Label>
                            <Form.Control
                            value={publisher}
                            onChange={(e)=>{
                                setPublisher(e.target.value)
                            }}
                            isInvalid={isError && !publisher}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.content}</Form.Label>
                            <SunEditor width="100%" height="300" setOptions={{
                                buttonList: [
                                    ['undo', 'redo'],
                                    ['font', 'fontSize', 'formatBlock'],
                                    ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                                    ['fontColor', 'hiliteColor'],
                                    ['outdent', 'indent'],
                                    ['align', 'horizontalRule', 'list', 'lineHeight'],
                                    ['table', 'link'],
                                    ['fullScreen', 'showBlocks'],
                                ]
                            }} 
                            setContents={content}
                            onChange={setContent}
                            
                            />
                        </Form.Group>
                        <hr/>
                        <Form.Group>
                            <Form.Label>{lang.thumbnail}</Form.Label>
                            <Button 
                            style={{display: "block"}} 
                            variant="secondary"
                            onClick={()=>setShowImageModal(true)}>
                                {lang.select_image}
                            </Button>
                            { selectedThumbnail.imageId !== null ?
                            <ImagePreview 
                            imagePath={selectedThumbnail.path}
                            onClickDelete={()=>setSelectedThumbnail({imageId: null, path: null})}
                            />
                            : null
                            }
                            <ImageModal 
                            show={isShowImageModal} 
                            onCallbackImage={(image)=>{
                                setSelectedThumbnail(image)
                                setShowImageModal(false)
                            }}
                            onHide={()=>setShowImageModal(false)}
                            />
                        </Form.Group>
                        <hr/>
                        <Form.Group>
                            <Form.Label>{lang.news_image}</Form.Label>
                            <Button 
                            onClick={()=>setShowMultipleImageModal(true)}
                            style={{display: "block"}} 
                            variant="secondary">
                                {lang.select_image}
                            </Button>
                            <ImageModal
                            show={isShowMultipleImageModal}
                            onHide={()=>setShowMultipleImageModal(false)}
                            onCallbackImage={(images)=>{
                                images.forEach((item)=>{
                                    if(!headerImages.some(el=>el.imageId === item.imageId)){
                                        setHeaderImages(oldArr => [...oldArr, item])
                                    }
                                    if(!prevImages.some(el=>el.imageId === item.imageId)){
                                        setToAddImage(oldArr => [...oldArr, item])
                                    }
                                })
                                setShowMultipleImageModal(false)
                            }}
                            multipleSelect
                            />
                            <Row>
                            { headerImages.map((item, key)=>
                                <Col key={key} xs={4}>
                                    <ImagePreview
                                    imagePath={item.path}
                                    style={{height:150}}
                                    onClickDelete={()=>{
                                        if(prevImages.find(el=>el.imageId===item.imageId)){
                                            setToRemoveImage(oldArr => [...oldArr, item])
                                        }
                                        if(!prevImages.some(el=>el.imageId === item.imageId)){
                                            setToAddImage(toAddImage.filter(ar=>ar.imageId !== item.imageId))
                                        }
                                        setHeaderImages(headerImages.filter(ar=>ar.imageId !== item.imageId))
                                    }}
                                    />
                                </Col>
                            )}
                            </Row>
                        </Form.Group>
                        <hr/>
                        <Form.Group>
                            { role.checkPermission(prefixAuthority, globalAuthority) ?
                            <>
                            <Form.Label>{lang.publication}</Form.Label>
                            <div style={{display: "flex", marginBottom: 10}}>
                                <PublishItem 
                                icon={faGlobeAsia}
                                isSelected={publication === 0 ? true:false}
                                title={lang.public}
                                desc={lang.public_desc}
                                onClick={()=>switchPublication(0)}
                                />
                                <PublishItem 
                                icon={faUsers}
                                isSelected={publication === 2 ? true:false}
                                title={lang.department}
                                desc={lang.department_desc}
                                onClick={()=>switchPublication(2)}
                                />
                            </div>
                            </>
                            : null
                            }
                            { (publication === 1 || publication === 2) && (isGlobal || setSelectedCompany !== "") ?
                            <Form.Group>
                                <Form.Label>{lang.company}</Form.Label>
                                <Form.Control as="select"
                                disabled={!role.checkPermission(prefixAuthority, companyAuthority)}
                                value={selectedCompany}
                                onChange={(e)=>{
                                    let id = e.target.value
                                    setSelectedCompany(id)
                                    setDepartment([])
                                    setSelectedDepartment([])
                                    departmentList(id)
                                }}>
                                    <option value="">{lang.select_company}</option>
                                    { company.map((item, key) =>
                                    <option value={item.id} key={key}>
                                        {item.name}
                                    </option>
                                    )}
                                </Form.Control>
                            </Form.Group>
                             : null
                            }
                            { publication === 2 ?
                            <Form.Group>
                                <Form.Label>{lang.department}</Form.Label>
                                <MultiSelect
                                disabled={selectedCompany === "" ? true:false}
                                options={department}
                                value={selectedDepartment}
                                onChange={setSelectedDepartment}
                                />
                            </Form.Group>
                            : null
                            }
                            
                        </Form.Group>
                        <hr/>
                        <Form.Group>
                            <Form.Label>{lang.publish_date}</Form.Label>
                            <DatePicker 
                            selected={publicationDate}
                            onChange={(date)=>setPublicationDate(date)}
                            className="form-control" 
                            dateFormat="d MMMM yyyy - H:mm"
                            showTimeSelect/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.expire_date}</Form.Label>
                            <DatePicker 
                            selected={expireDate}
                            onChange={(date)=>setExpireDate(date)}
                            className="form-control" 
                            dateFormat="d MMMM yyyy - H:mm"
                            showTimeSelect
                            />
                        </Form.Group>
                        <hr/>
                        <Form.Group>
                            <Form.Label>{lang.type_news}</Form.Label>
                            <Row>
                                { newsType.map((item, key)=>
                                <Col xs={6} sm={4} md={6} lg={4}  key={key}>
                                    <TypeItem
                                    title={item.label}
                                    icon={item.icon}
                                    isSelected={selectedTypeNews === item.value ? true:false}
                                    onClick={()=>setTypeNews(item.value)}
                                    />
                                </Col>
                                )}
                            </Row>
                            {/* VOTE */}
                            { selectedTypeNews === newsType[1].value ?
                            <Form.Group>
                                <Form.Label>{lang.vote_choice}</Form.Label>
                                <div style={{display: 'flex', marginBottom: 20}}>
                                    <Form.Control
                                    style={{marginRight: 10}}
                                    placeholder={lang.vote_placeholder}
                                    value={voteOption}
                                    onChange={(e)=>setVoteOption(e.target.value)}
                                    />
                                    <Button
                                    variant="success"
                                    onClick={()=>addChoice()}
                                    >
                                        <FontAwesomeIcon icon={faPlus}/>
                                    </Button>
                                </div>
                                { voteChoices.map((item, key) =>
                                    <ChoiceItem 
                                    title={item} 
                                    onDeleteClick={()=>deleteChoice(item)}
                                    key={key}/>
                                )}
                                
                            </Form.Group>
                            : null
                            }
                            {/* Register */}
                            { selectedTypeNews === newsType[2].value ?
                            <Form.Group>
                                <Form.Label>{lang.maximum_register}</Form.Label>
                                <Form.Control
                                type="number"
                                value={maximumRegister}
                                onChange={(e)=>setMaximumRegister(e.target.value)}
                                />
                            </Form.Group>
                            : null
                            }
                            {/* Quiz */}
                            { selectedTypeNews === newsType[4].value ?
                            <Form.Group>
                                <Form.Label>{lang.quiz_choice}</Form.Label>
                                <div style={{display: 'flex', marginBottom: 20}}>
                                    <Form.Control
                                    style={{marginRight: 10}}
                                    placeholder={lang.quiz_placeholder}
                                    value={quizOption}
                                    onChange={(e)=>setQuizOption(e.target.value)}
                                    />
                                    <Button
                                    variant="success"
                                    onClick={()=>addChoice()}
                                    >
                                        <FontAwesomeIcon icon={faPlus}/>
                                    </Button>
                                </div>
                                { quizChoices.map((item, key) =>
                                    <ChoiceItem 
                                    title={item} 
                                    onDeleteClick={()=>deleteChoice(item)}
                                    onMarkAnswerClick={()=>selectAnswerChoice(item)}
                                    isAnswer={answerChoice.find(el=>el===item)}
                                    isQuiz={true}
                                    key={key}/>
                                )}
                                
                            </Form.Group>
                            : null
                            }
                        </Form.Group>
                        <hr/>
                        { role.checkPermission("_MENU_", "app.admin_visitor") ?
                        <>
                        <Form.Group>
                            <Checkbox 
                            checked={isShowVisitor}
                            onChange={()=>setIsShowVisitor(!isShowVisitor ? true: false)}
                            label={
                                <div className="optional-checkbox">
                                    <FontAwesomeIcon className='icon' icon={faWalking}/>
                                    <div>
                                        <div className="title">{lang.show_visitor}</div>
                                        <div className="desc">{lang.show_visitor_desc}</div>
                                    </div>
                                </div>
                            }/>
                        </Form.Group>
                        <hr/>
                        </>
                        : null
                        }
                        { role.checkPermission("_MENU_", "app.front_screen") ?
                        <>
                        <Form.Group>
                            <Checkbox 
                            checked={isShowInformationScreen}
                            onChange={()=>setIsShowInformationScreen(!isShowInformationScreen ? true :false)}
                            label={
                                <div className="optional-checkbox">
                                    <FontAwesomeIcon className='icon' icon={faWindowMaximize}/>
                                    <div>
                                        <div className="title">{lang.screen_display}</div>
                                        <div className="desc">{lang.screen_display_desc}</div>
                                    </div>
                                </div>
                            }/>
                        </Form.Group>
                        <hr/>
                        </>
                        : null
                        }
                        <Button
                        type="submit"
                        >
                            {lang.save_change}
                        </Button>
                    </Form>
                </Col>
            </Row>
        </div>
    )
}

function PublishItem(props){
    return(
        <div className="publish-item"
        role="button"
        tabIndex="0"
        aria-pressed="false"
        onKeyDown={(e)=>{
            if(e.key === "Enter"){
                props.onClick()
            }
        }}
        onClick={props.onClick}
        style={{
            borderColor: props.isError ? "red": "lightgray",
            color: props.isSelected ? "white" : "black",
            backgroundColor: props.isSelected ? "#0275d8": "white"
        }}
        >
            <div>
                <div className="icon">
                    <FontAwesomeIcon icon={props.icon}/>
                </div>
                <div className="title">{props.title}</div>
                <div className="desc"
                style={{color: props.isSelected ? "white" : "gray"}}>
                    {props.desc}
                </div>
            </div>
        </div>
    )
}

function TypeItem(props){
    return(
        <div 
        className="type-item"
        onClick={props.onClick}
        style={{
            color: props.isSelected ? "white" : "black",
            backgroundColor: props.isSelected ? "#0275d8": "white"
        }}>
            <div className="icon">
                <FontAwesomeIcon icon={props.icon}/>
            </div>
            
            <div className="title">
                {props.title}
            </div>
        </div>
    )
}

function ChoiceItem(props){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.news

    return(
        <div className="choice-item">
            <div>
                {props.title}
            </div>
            <div style={{display: 'flex'}}>
                { props.isQuiz ?
                <Button 
                size="sm"
                onClick={props.onMarkAnswerClick}
                variant={props.isAnswer ? "success": "secondary"}
                >
                    <FontAwesomeIcon 
                    icon={props.isAnswer ? faCheck : faTimes}/>
                   {props.isAnswer ? 
                    <span style={{marginLeft: 5}}>
                        {lang.answer}
                    </span>
                   : null}
                </Button>
                : null
                }
                <Button
                size="sm"
                variant="danger"
                style={{marginLeft: 10}}
                onClick={props.onDeleteClick}
                >
                    <FontAwesomeIcon icon={faTrash}/>
                </Button>
                
            </div>
        </div>
    )
}

function ImagePreview(props){
    return(
        <div 
        className="image-preview"
        style={props.style}
        onClick={props.onClick}>
            <img src={baseURL + props.imagePath} alt={props.imagePath}/>
            <div className="del-btn"
            onClick={props.onClickDelete}>
                <FontAwesomeIcon icon={faTrash}/>
            </div>
        </div>
    )
}

export default UpdateNews
